import { formatParamsGet, getDataFromServer } from "../util";

export const createInvite = (formProps) => getDataFromServer("POST", "/invite", formProps, true);

export const searchInvites = (filterParams) => {
  const params = formatParamsGet({
    page: 0,
    size: 200,
    sort: "name,asc",
    ...filterParams,
  });

  return getDataFromServer("GET", `/invite/search${params}`, null, true);
};

export const getInviteByToken = (token) => getDataFromServer("GET", `/invite/token/${token}`, null, false);


export const revokeInvite = (id) => getDataFromServer("PATCH", `/invite/${id}/revoke`, null, true);

export const resendInvite = (id) => getDataFromServer("POST", `/invite/${id}/resend`, null, true);